import {EnumObject} from "./enum-object";

export class ColorType2 extends EnumObject {
	public static readonly walnut = new ColorType2('w');

	public static readonly natural = new ColorType2('n');

	private constructor(code: string) {
		super(code);
	}
}
